import React, { useState, useRef, useEffect } from "react";
import ChatHistorySection from "./../../components/dashboard/chathistorysection";
import DatePicker from "react-datepicker";
import { Icon } from "@iconify/react";
import "react-datepicker/dist/react-datepicker.css";
import { Drawer } from "antd";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { getThread } from "../../APIs/chatApis"; 
import MarkedReact from "marked-react";



const QuestionMessage = ({ text, user }) => (
  <div className="question-div flex gap-[20px] items-center w-full">
    <div className="w-[40px] h-[38px] rounded-[31px] text-center flex justify-center items-center py-[3px] bg-[var(--Primary-color,#143A62)]">
      {/* <img src="../../assets/icons/doc.png" alt="Document" className="rounded-full" /> */}
      <h6 className="uppercase text-white font-semibold">
        {user?.username[0].toUpperCase()}
        </h6>
    </div>
    <div className="flex items-center justify-between gap-[20px] w-full px-[18px] py-[22px] rounded-[14px] border-2 border-solid border-[#E2E8F0]">
      <p className="text-blue font-bold medium">

                                 
        {text}</p>
    </div>
  </div>
);

const AnswerMessage = ({ text, avatar }) => (
  <div className="answer-div flex gap-[20px] items-center w-full">
    <img src="../../assets/icons/AIAvatar.svg" alt="AI Avatar" className="w-[40px] h-[40px]" />
    <div className="flex items-center shadow-[#E1E2EF] w-full shadow-lg px-[18px] py-[22px] rounded-[14px] bg-[#FFF]">
      <p className="text-blue font-medium small leading-[24px]">
      <MarkedReact>{text}</MarkedReact>
      </p>

    </div>
  </div>
);

const ChatHistory = () => {
  const { t } = useTranslation();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showHistory, setShowHistory] = useState(false);
  const [chatHistory, setChatHistory] = useState([]);
  const datePickerRef = useRef(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const location = useLocation();
  const { user } = location.state || {}; // Get user data from navigation state

  useEffect(() => {
      console.log("Fetching chat history for user ID:",user?._id
      );
      getThread(user?._id)  // Updated to use getThread
        .then((chatData) => {
          console.log("Fetched thread data:", chatData);
          console.log("Fetched messages:", chatData[0].messages);
          setChatHistory(chatData[0].messages); // Assuming chatData has a `messages` array
        })
        .catch((error) => {
          console.error("Error fetching thread data:", error);
        });
  
  }, [user?._id]);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };
  const questionText = "I need help with drafting a contract for a new business partnership.";
  const answerText =
    "Certainly! I can help you with that. Could you please provide the key details of the partnership? For example, the parties involved, contract duration, and any specific clauses you’d like to include.";
  const userInitial = "t";
  const avatar = "../../assets/icons/AIAvatar.svg";
  const yesterdayMessages = Array(3).fill(
    "Lorem ipsum dolor sit amet consectetur. Odio nunc dictum at integer."
  );

  const previous7DaysMessages = Array(4).fill(
    "Lorem ipsum dolor sit amet consectetur. Odio nunc dictum at integer."
  );

  const previous30DaysMessages = Array(13).fill(
    "Lorem ipsum dolor sit amet consectetur. Odio nunc dictum at integer."
  );

  const toggleHistory = () => setShowHistory((prev) => !prev);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setFocus();
    }
  };
  console.log(chatHistory)
  return (
    <>
      <div className="flex flex-col h-full">
        <div className="top bg-[#EFF0F2] rounded-t-[20px] px-[20px] py-[18px] flex items-center justify-between">
          <h5 className="small text-blue font-bold">{t("adminDashboard.chathistory.title")}</h5>
          <img
            src={`../../assets/icons/${showHistory ? "chat-opener" : "chat-closer"}.png`}
            alt="Close chat"
            className="cursor-pointer max-sm:hidden"
            onClick={toggleHistory}
          />
          <img
            src={`../../assets/icons/${showHistory ? "chat-opener" : "chat-closer"}.png`}
            alt="Close chat"
            className="cursor-pointer hidden max-sm:flex"
            onClick={toggleDrawer}
          />
        </div>
        <div className={`chat flex pl-[30px] pr-[15px] pt-[21px] pb-[10px] gap-[20px] `}>
          <div
            className={`conversation flex flex-col gap-[10px] pb-[11px] ${
              showHistory ? "max-w-[70%]" : "max-w-full"
            } w-full pr-[15px] overflow-y-auto max-h-[60vh] transition-all duration-500`}
          >
       {/* Map through chat history and render each message */}
       {chatHistory?.length > 0 ? (
              chatHistory.map((message, index) => (
                <div key={index}>
                  {/* Render Question and Answer messages based on the type of message */}
                  {message.role==="user" ? (
                    <QuestionMessage text={message.content} user={user} files={message.files} />
                  ) : (
                    <AnswerMessage text={message.content} avatar={message.avatar} />
                  )}
                </div>
              ))
            ) : (
              <p>No chat history available.</p> // Display if no chat history is found
            )}
            {/* <QuestionMessage text={questionText} initial={userInitial} />
            <AnswerMessage text={answerText} avatar={avatar} />
            <QuestionMessage text={questionText} initial={userInitial} />
            <AnswerMessage text={answerText} avatar={avatar} />
            <QuestionMessage text={questionText} initial={userInitial} />
            <AnswerMessage text={answerText} avatar={avatar} /> */}
          </div>

          <div
            className={`history hidden flex-col gap-[11px] rounded-[14px] ${
              showHistory ? "!opacity-1 !flex  max-w-[30%]" : "hidden opacity-0 max-w-0"
            } bg-[#FFF] shadow-[#E1E2EF] w-full shadow-lg p-[20px] transition-all duration-500`}
          >
            <p className="large text-blue font-bold">{t("adminDashboard.chathistory.title")}</p>
            <div className="flex items-center justify-between gap-[10px] rounded-[10px] p-[10px] border-[var(--stroke-weight-1,1px)] bg-[#FAFAFA] shadow-sm">
              <DatePicker
                selected={selectedDate}
                onChange={handleDateChange}
                className="text-[#8D8D8D] bg-transparent font-medium small font-montserrat w-full"
                dateFormat="MM/dd/yyyy"
                ref={datePickerRef}
              />
              <Icon
                icon="clarity:date-line"
                className="text-gray-500 cursor-pointer"
                onClick={handleIconClick}
                width={18}
                height={18}
              />
            </div>
            <div className="pr-[21px] overflow-y-auto flex flex-col gap-[26px] max-xxxl:max-h-[54vh] max-h-[40vh]">
              <ChatHistorySection title="Yesterday" messages={yesterdayMessages} />
              <ChatHistorySection title="Previous 7 Days" messages={previous7DaysMessages} />
              <ChatHistorySection title="Previous 30 Days" messages={previous30DaysMessages} />
            </div>
          </div>
        </div>
      </div>

      <div className="mobile-sidebar hidden max-md:flex relative">
        <Drawer
          placement="right"
          closable={false}
          onClose={toggleDrawer}
          open={isDrawerOpen}
          className="rounded-l-[20px] "
          width={280}
        >
          <div className="sidebar-container ">
            <img
              src={
                isDrawerOpen
                  ? "../../assets/icons/sidebarArrow-right.png"
                  : "../../assets/icons/sidebarArrow-left.png"
              }
              alt=""
              className="cursor-pointer absolute left-[-5%] z-[99999]"
              onClick={toggleDrawer}
            />

            <div
              className={`history  flex-col gap-[11px] rounded-[14px] !opacity-1 !flex  max-w-[100%] bg-[#FFF] shadow-[#E1E2EF] w-full shadow-lg p-[20px] transition-all duration-500`}
            >
              <p className="large text-blue font-bold">{t("adminDashboard.chathistory.title")}</p>
              <div className="flex items-center justify-between gap-[10px] rounded-[10px] p-[10px] border-[var(--stroke-weight-1,1px)] bg-[#FAFAFA] shadow-sm">
                <DatePicker
                  selected={selectedDate}
                  onChange={handleDateChange}
                  className="text-[#8D8D8D] bg-transparent font-medium small font-montserrat w-full"
                  dateFormat="MM/dd/yyyy"
                  ref={datePickerRef}
                />
                <Icon
                  icon="clarity:date-line"
                  className="text-gray-500 cursor-pointer"
                  onClick={handleIconClick}
                  width={18}
                  height={18}
                />
              </div>
              <div className="pr-[21px] overflow-y-auto flex flex-col gap-[26px]  ">
                <ChatHistorySection title="Yesterday" messages={yesterdayMessages} />
                <ChatHistorySection title="Previous 7 Days" messages={previous7DaysMessages} />
                <ChatHistorySection title="Previous 30 Days" messages={previous30DaysMessages} />
              </div>
            </div>
          </div>
        </Drawer>
      </div>
    </>
  );
};

export default ChatHistory;
